import 'lazysizes'
// eslint-disable-next-line import/extensions
import 'lazysizes/plugins/attrchange/ls.attrchange'
import './critical/click-tracking'
import './critical/accordion'
import './css/main-confused.css'
import './critical/tab'
import './critical/provider-logo'
import 'lite-youtube-embed/src/lite-yt-embed.css'
import 'lite-youtube-embed/src/lite-yt-embed.js'
import './critical/platinum-tooltip'
import './critical/sticky-top-nav'
import './critical/chart'
import './critical/carousel'
import './critical/triage'

if (typeof window.nerdalytics !== 'undefined') {
  window.nerdalytics.page()
}
